import { Nullable } from "uikit";

// eslint-disable-next-line import/prefer-default-export
export const checkSipForActivity = (lastCheckMs: Nullable<string>) => {
	const isActive = Number(lastCheckMs) < 1;
	return isActive;
};
